import subscriptionStrings from "rivals/shared/strings/subscription";

function includedWith(addOnName: string): string {
  return `Included with purchase of ${addOnName}`;
}

export default {
  ...subscriptionStrings,
  addOns: "Add Ons",
  billingToday: "Billing Today",
  creditCard: "Credit Card",
  estimatedTax: "Estimated Tax",
  free: "FREE",
  includedWith,
  payPalAccount: "Paypal",
  paymentMethod: "Payment Method",
  prorated: "(pro-rated)",
  readOnlyAccess: "Read-only access to all forums in the Rivals network",
  spyOnRivals: "Spy on Your Rival Bundle",
  total: "Total"
};
